<template>
  <div class="guidesDoc">
    <div class="doc-nav">
      <div class="header-left">
        <div class="menu-item">
          <div>
            <router-link style="margin-left: 0;" :to="gotoMain()">{{menu.lev1}}</router-link>>
            <router-link :to="gotoMain()">{{menu.lev2}}</router-link>
          </div>
        </div>
      </div>
      <div class="header-right">
        <a v-if="!$root.$data.wiseStack && docInfo && docInfo.docType==='PDF'"
           :href="getPdfHref(docInfo.link)" title="Download PDF"
           class="header-right-button download">
          <i class="icon-download"></i>
          <span>PDF</span>
        </a>
        <div class="header-right-button feedback" @click="gotoFeedback" v-if="!this.$root.$data.wiseStack">
          <i class="icon-feedback"></i>
          <span>{{$t("Feedback")}}</span>
        </div>
        <div class="header-right-button mb-closesideMenu" @click="toggleSideMenu">
          <i class="icon-sideMenu"></i>
        </div>
      </div>
    </div>
    <div class="doc-warning-dialog" v-if="noDocWarningShow">
      <div>
        <i class="icon-warning"></i>
        <span>{{$t("not_available_in_your_lang") + $t(docInfo.lang) + $t("is_lang_version")}}</span>
      </div>
      <el-button
        icon='tp-icon-close'
        type="icon"
        size="small"
        @click="noDocWarningShow=false"/>
    </div>
    <div class="mainContent" :class="{mainContent_stack:this.$root.$data.wiseStack}">
      <aside class="sideMenuWrap scroll" v-show="sideMenuOpen">
        <div class="sideMenu scroll">
          <div class="menuLevl3">{{menu.lev3}}</div>
          <el-tree
            ref="tree"
            v-if="productLineMenu && productLineMenu.length>0"
            :data="productLineMenu"
            :current-node-key="productLineMenuDefaultNodeId"
            :default-expanded-keys="productLineMenuDefaultExpandNodeId"
            class="sideMenuNode"
            node-key="id"
            @node-click="handleNodeClick">
            <span slot-scope="{ node, data }" class="el-tree-node__label">
              <span>{{ node.label }}<i v-if="data.docType==='VIDEO'"></i></span>
            </span>
          </el-tree>
        </div>
      </aside>
      <div class="closesideMenu" @click="toggleSideMenu" :class="{sideMenuClose:!sideMenuOpen}">
        <el-tooltip placement="bottom-start" effect="light">
          <div slot="content" style="padding:0 6px 0 6px;line-height:16px;">{{$t("split_bar")}}</div>
          <i class="drag"></i>
        </el-tooltip>
      </div>
      <div class="mdFile" :class="{'mdFile-mb-hide':sideMenuOpen}" >
        <doc-content ref="child" v-if="activeDoc" :doc-info="docInfo" :video-info="videoInfo"></doc-content>
      </div>
    </div>
  </div>
</template>

<script>
import docContent from '@/components/FrontStage/Doc/DocContent.vue'
import docAPI from '@/api/backstage/doc'

export default {
  name: 'Doc',
  components: {
    docContent
  },
  data () {
    return {
      oldLang: 1,
      footerVisibleHeight: 0,
      activeDoc: false,
      noDocWarningShow: false,
      sideMenuOpen: true,
      lastWindowInnerWidth: '',
      docInfo: {},
      videoInfo: {
        sources: [],
        refs: []
      },
      menu: {
        lang: 1,
        lev1: '',
        lev2: '',
        lev3: '',
        menuName: ''
      },
      productLineMenu: null,
      productLineMenuDefaultNodeId: '',
      productLineMenuDefaultExpandNodeId: []
    }
  },
  created () {
    this.sideMenuOpen = window.innerWidth > 635
    this.switchLang()
    this.getMenuAndDoc()
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.windowResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.windowResize)
  },
  watch: {
    $route (to, from) {
      if (this.$i18n.locale === this.oldLang) {
        this.getDoc()
      } else {
        this.activeDoc = false
        this.noDocWarningShow = false
        this.switchLang()
        this.getMenuAndDoc()
      }
    }
  },
  methods: {
    switchLang () {
      this.menu.lang = this.$store.getters.getLangByKey(this.$i18n.locale).langId
      this.oldLang = this.$i18n.locale
    },
    getMenuAndDoc () {
      docAPI
        .getDocMenu(
          'menuName=' +
          this.$route.params.menuLevel1 +
          '&lang=' + this.menu.lang + '&level=3'
        ).then(resp => {
          let pathExist = false
          for (let child of resp.data.menu.children) {
            if (child.menuName === this.$route.params.menuLevel2) {
              for (let grandChild of child.children) {
                if (grandChild.menuName === this.$route.params.menuLevel3) {
                  this.menu.lev3 = this.getTitle(this.menu.lang, grandChild.title, 'title')
                  pathExist = true
                  break
                }
              }
              if (pathExist) {
                this.menu.lev2 = this.getTitle(this.menu.lang, child.title, 'title')
                break
              }
            }
          }
          if (pathExist) {
            this.menu.lev1 = this.getTitle(this.menu.lang, resp.data.menu.title, 'title')
            this.getProductLineMenu()
          } else {
            this.$router.push({ name: 'frontNotFound' })
          }
        }).catch(err => {
          console.log('queryMenu error---', err)
          this.$router.push({ name: 'frontNotFound' })
        })
    },
    getProductLineMenu () {
      docAPI
        .getDocMenu(
          'menuName=' +
          this.$route.params.menuLevel3 +
          '&lang=' + this.menu.lang + '&level=2'
        )
        .then(resp => {
          if (resp.data) {
            this.menu.menuName = resp.data.menu.menuName
            if (resp.data.menu.children) {
              this.productLineMenu = resp.data.menu.children.sort(function (a, b) {
                return a.order - b.order
              })
              this.formatProductLineMenu(this.productLineMenu)
              this.productLineMenuDefaultExpandNodeId = []
              this.productLineMenuDefaultNodeId = ''
              this.docInfo.docName = this.$route.params.docName
              if (this.docInfo.docName && this.isNodeInProductLineMenu(this.productLineMenu, this.docInfo.docName)) {
                this.getDoc(this.docInfo.docName)
              } else {
                this.$router.push({ name: 'frontNotFound' })
              }
            } else {
              this.$router.push({ name: 'frontNotFound' })
            }
          } else {
            this.$router.push({ name: 'frontNotFound' })
          }
        })
        .catch(err => {
          console.log('queryMenu error---', err)
          this.$router.push({ name: 'frontNotFound' })
        })
    },
    formatProductLineMenu (child) {
      if (child && child.length > 0) {
        for (let item of child) {
          item.label = this.getTitle(this.menu.lang, item.title, 'title')
          item.name = (item.type === 'menu') ? item.menuName : item.docName
          item.id = item.name + item.type
          if (item.children && item.children.length) {
            item.children = item.children.sort(function (a, b) {
              return a.order - b.order
            })
            this.formatProductLineMenu(item.children)
          }
        }
      }
    },
    isNodeInProductLineMenu (menu, name) {
      if (menu && menu.length > 0) {
        for (let item of menu) {
          if (item.type === 'doc' && item.name === name) {
            this.docInfo.docTitle = this.getTitle(this.menu.lang, item.title, 'title')
            this.docInfo.docType = item.docType
            this.productLineMenuDefaultNodeId = item.id
            return true
          }
          if (this.isNodeInProductLineMenu(item.children, name)) {
            this.productLineMenuDefaultExpandNodeId.push(item.name + item.type)
            return true
          }
        }
        return false
      } else {
        return false
      }
    },
    getDoc () {
      let version = this.$route.params.version
      let docName = this.$route.params.docName
      docAPI
        .getDocInfo(
          'docName=' + docName +
          '&lang=' + this.menu.lang
        ).then(resp => {
          let versionExist = false
          for (let item of resp.data.list) {
            if (item.version === version) {
              versionExist = true
              this.docInfo.version = item.version
              this.docInfo.id = item.id
              this.docInfo.forumId = this.menu.menuName
              this.docInfo.time = item.lastUpdatedTime
              this.getDocContent()
              this.docInfo.sideMenuOpen = this.sideMenuOpen
            }
          }
          if (!versionExist) {
            this.$router.push({ name: 'frontNotFound' })
          }
        }).catch(err => {
          console.log('queryMenu error---', err)
          this.$router.push({ name: 'frontNotFound' })
        })
    },
    getDocContent () {
      this.activeDoc = false
      docAPI
        .getDocContent(
          'docName=' + this.docInfo.docName +
          '&version=' + this.docInfo.version +
          '&lang=' + this.menu.lang
        ).then(resp => {
          if (resp.data && resp.data.status === 'success') {
            let data = resp.data
            if (data.docList) {
              this.docInfo.content = data.docList[0].artical
              this.docInfo.link = data.docList[0].link
              if (this.docInfo.docType === 'VIDEO' && this.docInfo.content) {
                let videoContent = this.docInfo.content
                this.docInfo.content = videoContent.substring(videoContent.indexOf('<TDMD>') + 6, videoContent.indexOf('</TDMD>'))
                this.videoInfo.refs = JSON.parse(videoContent.substring(videoContent.indexOf('<TDVideoRefs>') + 13, videoContent.indexOf('</TDVideoRefs>')))
                this.videoInfo.sources = []
                let sources = JSON.parse(videoContent.substring(videoContent.indexOf('<TDVideoSources>') + 16, videoContent.indexOf('</TDVideoSources>')))
                for (let i = 0; i < sources.length; i++) {
                  const source = sources[i]
                  if (source.link.endsWith('.swf')) {
                    source.type = 'embed'
                  } else {
                    source.type = 'iframe'
                  }
                  this.videoInfo.sources.push(source)
                }
              }
              this.activeDoc = true
            }
          }
        }).catch(err => {
          console.log('queryMenu error---', err)
          // this.$router.push({ name: 'frontNotFound' })
        })
    },
    handleNodeClick (data) {
      this.$refs.tree.setCurrentKey(this.docInfo.docName + 'doc')
      this.noDocWarningShow = false
      if (data.docType === 'M.D.' || data.docType === 'PDF' || data.docType === 'API' || data.docType === 'VIDEO') {
        if (window.innerWidth <= 635) {
          this.sideMenuOpen = false
        }
        // this.$router.replace({
        //   params: {
        //     docName: data.name.trim()
        //   }
        // })
      }
    },
    toggleSideMenu () {
      this.sideMenuOpen = !this.sideMenuOpen
      if (window.innerWidth > 635) {
        this.$refs.child.sideMenuOpen = this.sideMenuOpen
      }
    },
    windowResize () {
      if (window.innerWidth <= 635 && this.lastWindowInnerWidth > 635 && this.sideMenuOpen) {
        this.sideMenuOpen = false
        this.$refs.child.sideMenuOpen = false
      } else if (window.innerWidth > 635 && this.lastWindowInnerWidth <= 635 && !this.sideMenuOpen) {
        this.sideMenuOpen = true
        this.$refs.child.sideMenuOpen = true
      }
      this.lastWindowInnerWidth = window.innerWidth
    },
    handleScroll () {
      let windowVisibleHeight = window.innerHeight
      let windowScrollHeight = document.documentElement.scrollHeight
      let scrollHeight = window.pageYOffset
      let tmp = 50 - (windowScrollHeight - windowVisibleHeight - scrollHeight)
      if (tmp < 0) {
        this.footerVisibleHeight = 0
      } else {
        this.footerVisibleHeight = tmp
      }
    },
    getPdfHref (url) {
      return window.location.origin + url
    },
    gotoFeedback () {
      this.$refs.child.clickMenu('feedbackBlock')
    },
    gotoMain () {
      if (this.$route.name === 'preview') {
        return { path: this.$route.path }
      } else {
        return this.$route.params.menuLevel1 === 'Guides_and_API_References' ? { name: 'main' } : { name: 'main-solution' }
      }
    },
    changeHtmlTitle (title) {
      document.title = title + ' | Technical Documentation | Advantech'
    },
    getTitle (langId, title, keyString) {
      if (!Array.isArray(title)) {
        return title
      } else {
        for (let item of title) {
          if (item.lang === langId) {
            return item[keyString]
          }
        }
        return ''
      }
    }
  }
}
</script>

<style lang="scss">
.no-header {
  .guidesDoc {
    .mainContent{
      .sideMenuWrap, .closesideMenu {
        max-height: calc(100vh - 106px);
      }
      @media (max-width: 950px) {
        .sideMenuWrap, .closesideMenu  {
          max-height: calc(100vh - 98px) !important;
        }
      }
      @media (max-width: 635px) {
        .sideMenuWrap {
          max-height: none !important;
        }
      }
    }
  }
  &.no-footer {
    .guidesDoc {
      .mainContent{
        .sideMenuWrap, .closesideMenu {
          max-height: calc(100vh - 56px);
        }
        @media (max-width: 950px) {
          .sideMenuWrap, .closesideMenu  {
            max-height: calc(100vh - 48px) !important;
          }
        }
        @media (max-width: 635px) {
          .sideMenuWrap {
            max-height: none !important;
          }
        }
      }
    }
  }
}
.mainContent{
  .sideMenuWrap{
    overflow-x: hidden;
    display: block;
    position: sticky;
    top: 56px;
    max-height: calc(100vh - 184px);
  }
  .closesideMenu {
    position: sticky;
    top: 56px;
    min-height: calc(100vh - 234px);
    max-height: calc(100vh - 184px);
  }
}
.sideMenu > .el-tree {
  margin-bottom: 16px;
}
.el-tree__empty-block > .el-tree__empty-text {
  display: none;
}
.scroll::-webkit-scrollbar {
  width: 10px;
}
.scroll::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 12px;
}
.scroll:hover::-webkit-scrollbar-thumb {
  background: #c8c8c8;
}
.scroll {
  -ms-scroll-chaining: chained;
  -ms-overflow-style: none;
  -ms-content-zooming: zoom;
  -ms-scroll-rails: none;
  -ms-content-zoom-limit-min: 100%;
  -ms-content-zoom-limit-max: 500%;
  -ms-scroll-snap-type: proximity;
  -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
  -ms-overflow-style: none;
}

.sideMenuNode{
  .el-tree-node__label{
    i {
      background-image: url('../../../assets/icon/btn_main_video_normal.svg');
      position: relative;
      right: -8px;
      display: inline-block;
      vertical-align: top;
      width: 24px;
      height: 24px;
    }
  }
  .is-current>.el-tree-node__content>.el-tree-node__label{
    i {
      content:url('../../../assets/icon/btn_main_video_active.svg');
    }
  }
}
</style>

<style lang="scss" scoped>
.guidesDoc {
  z-index: 3;
  background-color: white;
  position: relative;
  top: 0;
  transition: top 0.1s ease;
  .doc-nav {
    width: 100%;
    position: sticky;
    top: 0;
    border-bottom: 1px solid #c8c8c8;
    height: 56px;
    line-height: 55px;
    background: #fafafa;
    z-index: 2;
    display: flex;
    justify-content:flex-end;
    box-sizing: border-box;
    .header-left {
      padding-left: 50px;
      text-align: left;
      font-size: 14px;
      color: #787878;
      display: inline-block;
      margin-right:auto;
      .menu-item {
        cursor: default;
        display: inline-block;
        padding-right: 5px;
        line-height: initial;
        text-decoration: none;
        vertical-align: middle;
        div {
          overflow: hidden;
          white-space: nowrap;
          display: flex;
          a {
            font-size: 14px;
            font-weight: normal;
            color: #787878;
            cursor: pointer;
            text-decoration: none;
            border-bottom: solid 1px #787878;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-left: 6px;
            margin-right: 6px;
          }
        }
      }
    }
    .header-right {
      padding-right: 30px;
      text-align: right;
      font-size: 16px;
      color: #008cd6;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .header-right-button {
        text-decoration: none;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        padding-left: 2px;
        i {
          display: inline-block;
          width: 24px;
          height: 24px;
          line-height: 32px;
          background-size: 24px;
        }
        span {
          text-decoration: none;
          padding-left: 4px;
          padding-right: 6px;
          line-height: 32px;
          font-size: 16px;
          color: #008cd6;
        }
        &:hover {
          background-color: #e5f6ff;
        }
        &:active {
          background-color: #008cd6;
          span {
            color: #fff;
          }
        }
      }
      .download {
        .icon-download {
          background-image: url("../../../assets/icon/btn_download_blue_normal.svg");
        }
        &:active {
          .icon-download {
            background-image: url("../../../assets/icon/btn_download_white_normal.svg");
          }
        }
      }
      .feedback {
        .icon-feedback {
          background-image: url("../../../assets/icon/btn_feedback_blue_normal.svg");
        }
        &:active {
          .icon-feedback {
            background-image: url("../../../assets/icon/btn_feedback_white_normal.svg");
          }
        }
      }
      .mb-closesideMenu {
        display: none;
        .icon-sideMenu {
          background-image: url("../../../assets/icon/btn_main_changelog_normal.svg");
          &:hover {
            background-image: url("../../../assets/icon/btn_main_changelog_hover.svg");
          }
          &:active {
            background-image: url("../../../assets/icon/btn_main_changelog_active.svg");
          }
        }
      }
    }
  }
  .el-col {
    padding: 0;
    height: 56px;
    line-height: 56px;
  }
  .doc-warning-dialog{
    display: flex;
    position: sticky;
    top: 56px;
    z-index: 2;
    justify-content: space-between;
    padding: 24px 30px 24px 50px;
    border-bottom: 1px solid #c8c8c8;
    border-right: none;
    background-color: #ffecb3;
    div{
      padding-right: 8px;
      span{
        margin-left: 8px;
        line-height: 32px;
        font-size: 16px;
        font-weight: 500;
        color: #666666;
      }
    }
  }
  .mainContent {
    position: relative;
    display: flex;
    background: #fff;
    .mdFile {
      width: 100%;
      flex:1;
    }
    .sideMenuWrap {
      width: 330px;
      box-sizing: border-box;
      .sideMenu {
        padding-top: 18px;
        padding-left: 54px;
        padding-bottom: 30px;
        width: 252px;
        .menuLevl3 {
          line-height: 48px;
          font-size: 16px;
          font-weight: bold;
          font-family: "Roboto Bold", "Microsoft JhengHei";
          color: #004280;
          border-bottom: solid 1px #e6e6e6;
        }
      }
    }
    .closesideMenu {
      flex: none;
      width: 10px;
      cursor: pointer;
      background: #fafafa;
      transition: padding-left 0.2s;
      .drag {
        display: inline-block;
        z-index: 999;
        margin-top: 86px;
        margin-left: 3px;
        height: 21px;
        width: 4px;
        background-size: 4px;
        background-image: url("../../../assets/icon/btn_main_split_20_normal.svg");
        &:hover {
          background-image: url("../../../assets/icon/btn_main_split_20_hover.svg");
        }
        &:active {
          background-image: url("../../../assets/icon/btn_main_split_20_active.svg");
        }
      }
      &:hover {
      background: #e6e6e6;
      }
    }
    .sideMenuClose {
      margin-left: 20px;
    }
  }
  @media (max-width: 1035px) {
    .doc-nav {
      .header-left {
        padding-left: 40px;
      }
    }
    .doc-warning-dialog{
      padding: 16px 30px 16px 40px;
    }
    .mainContent {
      .sideMenuWrap {
        .sideMenu {
          padding-left: 44px;
        }
      }
    }
  }
  @media (max-width: 950px) {
    .doc-nav {
      height: 48px;
      line-height: 47px;
      .header-left {
        padding-left: 20px;
      }
      .header-right {
        padding-right: 0;
        width: 112px;
        .header-right-button {
          margin-right: 8px;
          margin-left: 0;
          background-color: #fafafa;
          span {
            display: none;
          }
          &:hover, &:active {
            background-color: transparent;
          }
        }
        .download {
          .icon-download {
            background-image: url("../../../assets/icon/btn_download_blue_normal.svg");
          }
          &:active {
            .icon-download {
              background-image: url("../../../assets/icon/btn_download_white_normal.svg");
            }
          }
        }
        .feedback {
          .icon-feedback {
            background-image: url("../../../assets/icon/btn_feedback_blue_normal.svg");
          }
          &:hover {
            .icon-feedback {
              background-image: url("../../../assets/icon/btn_main_feedback_hover.svg");
            }
          }
          &:active {
            .icon-feedback {
              background-image: url("../../../assets/icon/btn_feedback_white_normal.svg");
            }
          }
        }
      }
    }
    .doc-warning-dialog{
      top: 48px;
      padding: 16px 4px 16px 20px;
    }
    .mainContent {
      .sideMenuWrap {
        top: 48px;
        max-height: calc(100vh - 128px);
        .sideMenu {
          padding-left: 24px;
        }
      }
      .closesideMenu {
        top: 48px;
      }
    }
  }

  @media (max-width: 635px) {
    .doc-nav {
      .header-left {
        padding-left: 20px;
        max-width: calc(100% - 140px);
        overflow: hidden;
        .menu-item {
          width: -webkit-fill-available;
        }
      }
      .header-right {
        .mb-closesideMenu {
          display: flex;
        }
      }
    }
    .mainContent {
      .sideMenuWrap {
        background: #fff;
        width: 100%;
        max-height: none !important;
        .sideMenu {
          padding-left: 34px;
          padding-bottom: 0;
          padding-right: 20px;
          width: initial;
        }
      }
      .closesideMenu {
        display: none;
      }
    }
    .mdFile-mb-hide {
      display: none;
    }
  }
}
</style>
